import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	createNewView: {
		id: 'polaris-lib-create-view-popup.create-new-view',
		defaultMessage: 'Create a view',
		description: 'Jira Product Discovery menu item for creating a new view',
	},
});
